import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useMediaQuery } from 'react-responsive';
import cn from '../../../utils/cn';

// Components
import Button from '../../atoms/Button/Button';

// Images
import { ReactComponent as BlurCircles } from '../../../assets/images/blur_circles.svg';
import EmptyUsers from '../../../assets/images/empty_users.png';

import styles from './EmptyList.module.scss';

const themes = {
  users: <img className={styles.image} src={EmptyUsers} alt="empty" />,
};

function EmptyList({
  imageTheme, title, text, button,
}) {
  const isSmallMobile = useMediaQuery({ maxWidth: 500 });

  return (
    <div className="d-flex center m-t-20 m-b-40">
      <div className={cn([styles.max, 'd-flex d-col center'])}>
        {imageTheme ? (
          <div className="m-b-20">
            <BlurCircles className={styles.circles} />
            {themes[imageTheme]}
          </div>
        ) : null}

        <div className="d-flex d-col center p-relative">
          {title ? <h2 className="m-b-20 fs-24 fw-600 c-neutral-01">{title}</h2> : null}
          {text ? <p className="m-b-30 fs-16 fw-300">{text}</p> : null}

          {button?.label && button?.onClick ? (
            <div className="d-flex center w-100">
              <Button
                onClick={button.onClick}
                full={isSmallMobile}
              >
                {button.label}

              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

EmptyList.propTypes = {
  imageTheme: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  button: PropTypes.shape({ label: PropTypes.string, onClick: PropTypes.func }),
};

EmptyList.defaultProps = {
  imageTheme: null,
  title: null,
  text: null,
  button: null,
};

export default EmptyList;
